import { ExtendedRoom } from 'matrix/hooks/useDMRooms';
import { EventType, NotificationCountType } from 'matrix-js-sdk';
import { useMessageCommands } from '../../../matrix/commands/useMessageCommands';
import { MatrixRoomListItem } from './MatrixRoomListItem/MatrixRoomListItem';
import styles from './MatrixRoomListItem/MatrixRoomListItem.module.scss';

type MessagesProps = {
  onSelect: (roomId: string) => void;
  selected: string | null;
  rooms?: ExtendedRoom[];
};

export function MatrixRoomList({ onSelect, selected, rooms }: MessagesProps) {
  const { markAsRead } = useMessageCommands();
  return rooms?.map((room) => {
    const roomId = room.roomId;
    const lastUpdate = room.getLastActiveTimestamp();
    const unread = room.getUnreadNotificationCount(NotificationCountType.Total);
    const roomName = room.roomInformation.displayName || room.name || '';
    const roleName = room.roomInformation.profile?.roleName ?? '';
    const otherMatrixUserId = room.roomInformation.otherMatrixUserId;
    return (
      <MatrixRoomListItem
        onClick={async (roomId) => {
          await markAsRead(roomId);
          onSelect(roomId);
        }}
        isSelected={selected === roomId}
        lastUpdate={lastUpdate}
        roomName={roomName}
        unread={unread}
        badgeText={roleName}
        otherMatrixUserId={otherMatrixUserId}
        preview={
          room
            .getLiveTimeline()
            .getEvents()
            .filter((e) => e.getType() === EventType.RoomMessage)
            .pop()
            ?.getContent().body
        }
        roomId={roomId}
        className={styles.roomItem}
        key={roomId}
      />
    );
  });
}
